// frontend/src/components/Modal/PaymentModal.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import Modal from '../Modal/Modal';
import styled from 'styled-components';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { buildPaidCheckoutReturnUrl } from '../../utils/paidCheckoutParams';

const PaymentModal = ({ paymentSession, onPaymentResult, onClose }) => {
  const { t } = useTranslation('eventEnroll');
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setErrorMessage('');

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: buildPaidCheckoutReturnUrl({
          origin: window.location.origin,
          pathname: window.location.pathname,
          currentSearch: window.location.search,
          paymentId: paymentSession.paymentId,
          reservationId: paymentSession.reservationId
        }),
      },
      redirect: 'if_required'
    });

    if (error) {
      setErrorMessage(error.message);
      setLoading(false);
    } else {
      if (paymentIntent) {
        onPaymentResult({
          ...paymentSession,
          paymentIntentId: paymentIntent.id,
          stripeStatus: paymentIntent.status,
        });
      }
      setLoading(false);
    }
  };

  return (
    <Modal title={t('paymentStep.paymentModal.title')} onClose={onClose} maxWidth="500px">
      <Form onSubmit={handleSubmit}>
        {/* El PaymentElement usará la apariencia configurada en Elements */}
        <PaymentElement />
        {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
        <Button type="submit" disabled={!stripe || loading} size="l">
          {/* {loading ? 'Procesando...' : 'Pagar'} */}
          {loading ? t('paymentStep.paymentModal.processing') : t('paymentStep.paymentModal.pay')}
        </Button>
      </Form>
    </Modal>
  );
};

PaymentModal.propTypes = {
  paymentSession: PropTypes.shape({
    paymentId: PropTypes.string.isRequired,
    reservationId: PropTypes.string.isRequired,
    clientSecret: PropTypes.string,
    connectedAccountId: PropTypes.string,
  }).isRequired,
  onPaymentResult: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 100%;
`;

const ErrorText = styled.p`
  color: red;
`;

export default PaymentModal;
